import React from 'react';
import { muiArrowUp, muiArrowDown } from '@ally/metronome-icons';
import { Box } from '../../../Box';
import { Icon } from '../../../Icon';
const SortIndicator = ({ sortState, }) => {
    return (React.createElement(Box, { display: "flex", flexDirection: "column", justifyContent: "center" }, sortState !== 'none' && (React.createElement(Icon, { icon: sortState === 'ascending' ? muiArrowUp : muiArrowDown, size: "xs", fill: "slate-400", mr: "xxs", unsupportedCustomWidth: 7, unsupportedCustomHeight: 7, "data-testid": "mui-table-sort-indicator", ariaHidden: true }))));
};
export { SortIndicator };
//# sourceMappingURL=SortIndicator.js.map